var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileMoonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_283_13755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.79092 0.124024C5.00284 0.0800787 5.21475 0.0488287 5.42373 0.0283209C5.63858 0.00781307 5.85147 -0.00195256 6.06143 5.68088e-07C6.17959 0.000977131 6.27432 0.0976568 6.27334 0.215821C6.27237 0.306641 6.21475 0.38379 6.13467 0.414063C5.24112 0.765626 4.52627 1.4209 4.0878 2.23242C3.65616 3.03027 3.49209 3.97852 3.68838 4.93555L3.68936 4.94238C3.91299 6.02246 4.55166 6.91016 5.40616 7.47266C6.25967 8.03516 7.32705 8.27148 8.40713 8.05078L8.41397 8.0498C9.19131 7.88867 9.86807 7.51367 10.3964 6.99707C10.9433 6.46289 11.33 5.77832 11.5028 5.02832C11.5292 4.91309 11.6444 4.8418 11.7587 4.86816C11.8456 4.88867 11.9081 4.95899 11.9218 5.04199C12.1796 6.62402 11.7899 8.17383 10.9394 9.4082C10.0927 10.6367 8.78799 11.5537 7.21084 11.8779C5.5878 12.2119 3.9833 11.8564 2.70108 11.0127C1.41787 10.166 0.457914 8.83301 0.123929 7.20996C-0.202242 5.625 0.128812 4.05762 0.93057 2.79102C1.73623 1.52051 3.01553 0.550782 4.58096 0.170899C4.61123 0.163087 4.64639 0.155274 4.68448 0.146485H4.68545L4.79092 0.124024Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_283_13755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12.001,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMoonIcon);
export default __webpack_public_path__ + "static/media/mobile-moon-icon.d5ae1fb0a11ffa5e701fa2b7e2a4d093.svg";
export { ForwardRef as ReactComponent };